import React from 'react';
import './NotFound.scss'
import {Content} from "@carbon/react";

const NotFound = () => (
  <Content>
    <p>404 Not found!</p>
  </Content>
)

export default NotFound